module.exports = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n     uib-modal-animation-class=\"fade\"\n     modal-in-class=\"in\"\n     ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n  <div class=\"modal-dialog portlet modal-xlarge\" uib-modal-transclude dc-scrollbar></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html
// module id = 939
// module chunks = 12